module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-8.bd91cc88.svg";